import { CARDS_SIZE } from '@app/features/dashboard/enum/live-status';

export const POLLING_INTERVAL = {
    dashboard: 10000,
    timerRefresh: 1000,
    sidebar: 60000,
};

export const MAX_CARD_SIZE = {
    issues: CARDS_SIZE.big,
    noIssues: CARDS_SIZE.medium,
};

export const ISSUE_TYPES_HELP_LABEL = 'issue-types';

export const NOT_CONFIGURED_STATE = {
    id: 0,
    code: 'notConfigured',
    description: '',
    group: '',
};
